// extracted by mini-css-extract-plugin
export default {"settings-container":"settings_settings-container__-hClE"};